import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'

import { useApp } from 'src/modules/app/hooks'

import * as actions from './slice'
import { filterInvalidOptionsForCategory } from './utils'

export const useSuppliers = () => {
  const dispatch = useDispatch()
  const { lastPage } = useApp()
  const {
    category,
    sustainabilityFilterChoices: allSustainabilityFilterChoices,
    ...state
  } = useSelector(state => state.buyer.suppliers)

  const sustainabilityFilterChoices = filterInvalidOptionsForCategory(
    category,
    allSustainabilityFilterChoices
  )

  // Match /suppliers/<id>/
  const supplierPageRegex = /^\/suppliers\/\d+\/?/g
  const lastPageWasSupplier = supplierPageRegex.test(lastPage)

  // Match /suppliers/<section>/
  const supplierListRegex = /^\/suppliers\/[A-Za-z]+\/?/g
  const lastPageWasSupplierList = supplierListRegex.test(lastPage)

  return {
    ...bindActionCreators(actions, dispatch),
    ...state,
    category,
    sustainabilityFilterChoices,
    lastPageWasSupplier,
    lastPageWasSupplierList,
  }
}
